import { render, staticRenderFns } from "./CampaignEdit.vue?vue&type=template&id=6e8db89a&scoped=true&"
import script from "./CampaignEdit.vue?vue&type=script&lang=js&"
export * from "./CampaignEdit.vue?vue&type=script&lang=js&"
import style0 from "./CampaignEdit.vue?vue&type=style&index=0&id=6e8db89a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8db89a",
  null
  
)

export default component.exports